import * as Sentry from '@sentry/react'
import PropTypes from 'prop-types'
import { Component } from 'react'
import styled from 'styled-components'

import { colors, font, Button } from '@scouts/ui'

import { SUPPORT_EMAIL } from '../constants'

const Wrapper = styled.div`
    line-height: 1.5;
    margin: 24px;
`

const ErrorInfo = styled.pre`
    color: ${colors.text.neutral};
    font-size: ${font.small};
    white-space: pre-wrap;
`

const StrictCookieError = () => (
    <>
        <Wrapper>
            Las cookies de tu navegador están inhabilitadas. Por favor, comprueba tu configuración e inténtalo de nuevo.
        </Wrapper>

        <Wrapper>
            <Button
                onClick={() => {
                    window.location.reload()
                }}
            >
                Refrescar
            </Button>
        </Wrapper>
    </>
)
const GenericError = ({ errorMessage }) => (
    <>
        <Wrapper>
            ¡Ups! Ha habido un error inesperado. Por favor, carga nuevamente la página o contacta a {SUPPORT_EMAIL}
        </Wrapper>

        <Wrapper>
            <Button
                onClick={() => {
                    window.location.reload()
                }}
            >
                Refrescar
            </Button>
        </Wrapper>

        <Wrapper>
            <ErrorInfo>{errorMessage}</ErrorInfo>
        </Wrapper>
    </>
)
GenericError.propTypes = {
    errorMessage: PropTypes.string.isRequired,
}

class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = { errorMessage: '' }
    }

    static getDerivedStateFromError(error) {
        if (error.name === 'SecurityError' && error.code === 18) return { isStrictCookieError: true }

        return { errorMessage: error?.message }
    }

    componentDidCatch(error, errorInfo) {
        Sentry.withScope((scope) => {
            Object.keys(errorInfo).forEach((key) => {
                scope.setExtra(key, errorInfo[key])
            })
            Sentry.captureReactException(error)
        })
    }

    render() {
        const { children } = this.props
        const { errorMessage, isStrictCookieError } = this.state

        if (isStrictCookieError) return <StrictCookieError />
        if (errorMessage) return <GenericError errorMessage={errorMessage} />

        return children
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
}

export default ErrorBoundary
